/**
 * /devhub/scripts — Script runtime (operator). Surface Layer (/01). REQ-001.91 Phase 3.
 * Live operator panel (DevHubScriptRuntimePanel) wired to its useDevHub* hook over GET /api/control/registry/:name.
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */
import { createFileRoute } from '@tanstack/react-router';
import { DevHubScriptRuntimePanel } from '../features/control-plane/DevHubScriptRuntimePanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/scripts')({ component: ScriptsPage });

function ScriptsPage() {
  return (
    <DevHubPanelPage
      title="Script runtime"
      subtitle="Registered script routes and their runtime classification."
      status={{ label: 'live', live: true }}
    >
      <DevHubScriptRuntimePanel />
    </DevHubPanelPage>
  );
}
